import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { bakeryInfo } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { href: '#ueber-uns', label: 'Über Uns' },
  { href: '#services', label: 'Services' },
  { href: '#produkte', label: 'Produkte' },
  { href: '#torten', label: 'Torten' },
  { href: '#bewertungen', label: 'Bewertungen' },
  { href: '#kontakt', label: 'Kontakt' }];


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled ?
      'bg-[#f7f5f2]/95 backdrop-blur-md shadow-lg py-3' :
      'bg-transparent py-5'}`
      }>

      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#" className="group">
          <h1 className={`font-bold text-xl transition-colors duration-300 ${
            isScrolled ? 'text-[#1e1919]' : 'text-white'
          }`}>
            {bakeryInfo.name}
          </h1>
          <p className={`text-xs transition-colors duration-300 ${
            isScrolled ? 'text-[#736c64]' : 'text-white/80'
          }`}>
            Seit {bakeryInfo.yearsFounded} Jahren
          </p>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) =>
          <a
            key={link.href}
            href={link.href}
            className={`text-sm font-medium transition-all duration-300 hover:opacity-70 relative after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-[2px] after:bg-[#61525a] after:transition-all after:duration-300 hover:after:w-full ${
            isScrolled ? 'text-[#1e1919]' : 'text-white'}`
            }>

              {link.label}
            </a>
          )}
        </nav>

        {/* Phone CTA */}
        <a
          href={`tel:${bakeryInfo.phone}`}
          className="hidden md:flex items-center gap-2 bg-[#61525a] text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 hover:bg-[#4a3f45] hover:shadow-lg hover:-translate-y-0.5">

          <Phone className="w-4 h-4" />
          <span>{bakeryInfo.phone}</span>
        </a>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`lg:hidden p-2 rounded-lg transition-colors duration-300 ${
          isScrolled ? 'text-[#1e1919]' : 'text-white'}`
          }>

          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-[#f7f5f2] shadow-lg transition-all duration-300 overflow-hidden ${
        isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`
        }>

        <nav className="flex flex-col p-6 gap-4">
          {navLinks.map((link) =>
          <a
            key={link.href}
            href={link.href}
            onClick={() => setIsMobileMenuOpen(false)}
            className="text-[#1e1919] font-medium py-2 border-b border-[#e5e2df] last:border-0 transition-colors duration-300 hover:text-[#61525a]">

              {link.label}
            </a>
          )}
          <a
            href={`tel:${bakeryInfo.phone}`}
            className="flex items-center justify-center gap-2 bg-[#61525a] text-white px-5 py-3 rounded-full text-sm font-medium mt-2">

            <Phone className="w-4 h-4" />
            <span>{bakeryInfo.phone}</span>
          </a>
        </nav>
      </div>
    </header>);

};

export default Header;